/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { CURRENT_TCAS_YEAR } from 'constants/school-year';
import cn from 'classnames';
import { callAPI, getRoundDescription, getRoundState, userErrorMessage, showErrorToast } from 'helpers';
import { EMPTY_ROUND } from '../round-data';
import _ from 'lodash';

// Components
import RoundContent from '../RoundContent';
import ModalOfferReplyConsent from './ModalRound1OfferReplyConsent';
import ModalOfferCancelConsent from './ModalRound1OfferCancelConsent';

// Hooks
import { useSelector } from 'react-redux';
import useQuery from 'hooks/useQuery';

const roundType = `1_${CURRENT_TCAS_YEAR}`;
const Round1 = ({ enrollment }) => {
  const profile = useSelector((state) => _.get(state, 'app.user') || {});
  const query = useQuery();

  const [active, setActive] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const { loading, loadFailed, timestamp } = enrollment;
  const { offers, replies, offerCount } = enrollment.byType[roundType] || EMPTY_ROUND;
  const { flow } = getRoundState({
    roundType,
    timestamp,
    query
  });
  const description = loading ? null : getRoundDescription({ roundType, timestamp, offers, replies });

  useEffect(() => {
    if (flow === 'default' && !_.get(profile, `consents_accepted_at.offer_reply_1_${CURRENT_TCAS_YEAR}`)) {
      // In reply period, and has not accepted the reply consent yet.
      setModalVisible(true);
    } else if (flow === 'cancel' && !_.get(profile, `consents_accepted_at.offer_cancel_1_${CURRENT_TCAS_YEAR}`)) {
      // In cancel period, and has not accepted the cancel consent yet.
      setModalVisible(true);
    }
  }, [flow, profile]);

  const [accepting, setAccepting] = useState(false);
  const _onAcceptConsent = async (consentType) => {
    if (accepting) return;
    try {
      setAccepting(true);
      await callAPI({
        method: 'POST',
        url: '/applicants/me/consents',
        body: {
          consentType,
        },
      });
      setAccepting(false);
    } catch (error) {
      console.error(`Error while trying to accept consent: ${error.message}`);
      showErrorToast(userErrorMessage(error));
      setAccepting(false);
    }
    setModalVisible(false);
  };

  return (
    <>
      <div className={cn('r-1', { active })}>
        <header onClick={() => setActive((_active) => !_active)}>
          <b>
            <small>{'รอบ'}</small>1
          </b>
          <h3>
            Portfolio
            {description && <small>{(description)}</small>}
          </h3>
          <i className="i-down"></i>
        </header>
        <RoundContent
          flow={flow}
          roundType={roundType}
          loading={loading}
          loadFailed={loadFailed}
          offerCount={offerCount}
          offers={offers}
          replies={replies}
          timestamp={timestamp}
        />
      </div>
      <ModalOfferReplyConsent
        visible={offers.length && modalVisible && flow === 'default'}
        onSubmit={() => _onAcceptConsent(`offer_reply_1_${CURRENT_TCAS_YEAR}`)}
      />
      <ModalOfferCancelConsent
        visible={offers.length && _.get(_.last(replies), 'program_project') && modalVisible && flow === 'cancel'}
        onSubmit={() => _onAcceptConsent(`offer_cancel_1_${CURRENT_TCAS_YEAR}`)}
      />
    </>
  );
};

export default Round1;
